import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class DocumentActionService {

    private convertBase64ToBlob(base64String: string, mimeType: string): Blob {
        const base64Data = base64String.replace(/^data:.+;base64,/, '');
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        return blob;
    }

    public downloadDocument(data: Blob) {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.click();
    }

    public downloadDocumentWithFilename(data: Blob, fileName: string) {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    public downloadBase64Document(base64String: string, mimeType: string, fileName: string) {
        const blob = this.convertBase64ToBlob(base64String, mimeType);
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();

        URL.revokeObjectURL(url);
    }

    public openBase64Document(base64String: string, mimeType: string) {
        const blob = this.convertBase64ToBlob(base64String, mimeType);
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.target = '_blank';
        link.click();
    }

    public openDocument(blob: Blob) {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.target = '_blank';
        link.click();
    }

    public printBase64Document(base64String: string, mimeType: string, fileName: string) {
        const blob = this.convertBase64ToBlob(base64String, mimeType);
        const fileURL = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = fileURL;
        document.body.appendChild(iframe);

        iframe.onload = () => {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();

            // Smisliti bolji način uništavanja elementa i URL-a
            setTimeout(() => {
                document.body.removeChild(iframe);
                URL.revokeObjectURL(fileURL);
            }, 10000);
        };
    }

    public getFileNameFromResponse(response: HttpResponse<Blob>): string {
        const contentDisposition = response.headers.get('content-disposition');
        if (!contentDisposition) return 'download.csv';
        const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
        return matches?.[1] ?? 'download.csv';
    }
}